import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './AykCtaPanel.css'

const cards = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
    title: 'Fund ratings & scores',
    body: 'Climate and social impact ratings for mutual funds and ETFs across all screening categories.',
  },
  // {
  //   icon: (
  //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
  //       <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
  //       <line x1="8" y1="21" x2="16" y2="21" />
  //       <line x1="12" y1="17" x2="12" y2="21" />
  //     </svg>
  //   ),
  //   title: 'Asset manager voting data',
  //   body: "How the world's largest asset managers vote on shareholder resolutions — ESG, climate, and governance.",
  // },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
    title: 'Retirement plan data',
    body: 'Structured data behind the 401(k) scorecards — fossil fuels, weapons, prison, and more, across 70+ plans.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
    title: 'Commercial license',
    body: "Financial advisors, fund managers, fintechs, and data aggregators can license Invest Your Values data.",
  },
]

@CSSModules(Styles)
export default class AykCtaPanel extends Component {
  static propTypes = {
    portalUrl: PropTypes.string,
    contactEmail: PropTypes.string,
  }

  static defaultProps = {
    portalUrl: 'https://sq9eb.share.hsforms.com/2h7XyBWSvTL-RdM-N0_OnOQ',
    contactEmail: 'data@asyouknow.com',
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { portalUrl, contactUrl, contactEmail } = this.props

    return (
      <div styleName='data-access'>
        <div styleName='data-access__inner'>

          <p styleName='data-access__eyebrow'>POWERED BY AS YOU SOW</p>
          <h2 styleName='data-access__headline'>License the underlying data</h2>
          <p styleName='data-access__intro'>
            This data is free for personal, educational, and non-commercial use.
            Commercial or for-profit use requires a license from <strong>As You Know</strong>.
          </p>

          <div styleName='data-access__cards'>
            {cards.map((card, i) => (
              <div key={i} styleName='data-access__card'>
                <div styleName='data-access__card-icon'>
                  {card.icon}
                </div>
                <h3 styleName='data-access__card-title'>{card.title}</h3>
                <p styleName='data-access__card-body'>{card.body}</p>
              </div>
            ))}
          </div>

          <div styleName='data-access__actions'>
            <a target="_blank" href={portalUrl} styleName='data-access__btn-primary'>
              License the data ↗
            </a>
            {/*
            <a href={`mailto:${contactEmail}`} styleName='data-access__btn-secondary'>
              Contact us
            </a>
            */}
          </div>

          <p styleName='data-access__footer'>
            Questions? Contact {' '}
            <a href={`mailto:${contactEmail}`} styleName='data-access__email'>
              {contactEmail}
            </a>
          </p>

        </div>
      </div>
    )
  }
}